import React, { Fragment, useState } from "react";
import { useMediaQuery } from "react-responsive";
import logo from "../../assets/PITA_logo.svg";
import logo2 from "../../assets/PITA_logo_black.svg";
import { useLanguage } from "../context/LanguageContext";

const Navbar = () => {
  const [burgerMenu, setBurger] = useState([
    "burger-menu__inside",
    "navbar__nav",
  ]);
  let burgerStatus = "";
  const activeLanguage = useLanguage();
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

  function toggleMenu() {
    if (burgerMenu[0] === "burger-menu__inside") {
      burgerStatus = ["burger-menu__inside open", "navbar__nav open-mobile"];
    } else {
      burgerStatus = ["burger-menu__inside", "navbar__nav"];
    }
    setBurger(burgerStatus);
  }

  // Once it is time to fix this, uncomment everything (note that where there is a mention of logo2, maybe it will remain commented) and relink get free consultation to the right area.

  return (
    <Fragment>
      <nav className="navbar">
        {/* <div className="burger-menu" onClick={toggleMenu}>
          <div className={burgerMenu[0]}></div>
        </div> */}
        <div className="navbar__logo">
          <a href="https://bernardompita.com">
            <img
              className="navbar__logo__img"
              alt="logo"
              src={logo}
              // src={isMobile ? logo2 : logo}
            />
          </a>
        </div>
        {/* <div className={burgerMenu[1]}>
          <a href="https://bernardompita.com/services" className="navbar__item">
            {activeLanguage.nav.p0}
          </a>
          <span className="colored">/</span>
          <a href="https://bernardompita.com/the-team" className="navbar__item">
            {activeLanguage.nav.p1}
          </a>
          <span className="colored">/</span>
          <a href="https://bernardompita.com/blog" className="navbar__item">
            {activeLanguage.nav.p2}
          </a>
          <span className="colored">/</span>
          <a href="https://bernardompita.com/contact" className="navbar__item">
            {activeLanguage.nav.p3}
          </a>
          <span className="colored">/</span>
          <div className="navbar__item navbar__item--active">
            {activeLanguage.nav.p4}
          </div>
        </div> */}
        <div className="navbar__button__container">
          <a href="https://bernardompita.com/" target="_blank">
            <button
              className="navbar__button"
              style={isMobile ? { display: "none" } : {}}>
              {activeLanguage.nav.p5}
            </button>
          </a>
          <a href="https://bernardompita.com/contact">
            <button
              className="navbar__button"
              style={isMobile ? {} : { display: "none" }}>
              <i className="fas fa-envelope" />
            </button>
          </a>
        </div>
      </nav>
    </Fragment>
  );
};

export default Navbar;
